import * as React from 'react';
import { IconType } from 'react-icons/lib';
import styles from './button.scss';

export interface ButtonProps extends Partial<HTMLElement> {
  icon?: IconType;
  iconStyle?: string;
  onClick?: (event: any) => void;
  inputGroupBtn?: boolean;
  disabled?: boolean;
  dataDismiss?: string;
  dataToggle?: string;
  dataTarget?: string;
  ariaControls?: string;
  autoFocus?: boolean;
  children?: any;
  classNames?: string;
  tabIndex?: number;
}

interface ButtonComponentProps extends ButtonProps {
  btnType: string;
}

export class Button extends React.Component<ButtonComponentProps> {
  private onKeyDown = (e: any) => {
    // On press enter
    if (e.keyCode === 13) {
      e.preventDefault();
      this.props.onClick(e);
    }
  };

  public render() {
    const Icon = this.props.icon;

    return (
      <button
        id={this.props.id}
        type="button"
        className={`${this.props.btnType ? 'btn ' + this.props.btnType : ''} ${this.props.classNames ? this.props.classNames : ''}`}
        onClick={this.props.onClick}
        onKeyDown={this.onKeyDown}
        disabled={this.props.disabled}
        data-dismiss={this.props.dataDismiss}
        data-toggle={this.props.dataToggle}
        data-target={this.props.dataTarget}
        aria-controls={this.props.ariaControls}
        autoFocus={this.props.autoFocus}
        tabIndex={this.props.tabIndex}>
        {this.props.icon && <Icon className={`${styles.btnIcon} ${this.props.iconStyle}`} />}
        {React.Children.count(this.props.children) !== 0 ? <span>{this.props.children}</span> : null}
      </button>
    );
  }
}
